<template>
  <div>
    <div class="picture">
      <div class="boack" >
        <canvas
          id="background"
        >
        </canvas>
      </div>
      <div class="boack" >
        <canvas id="line" >
        </canvas>
      </div>
    </div>

  </div>
</template>
<script>
// import { ecglist } from "./js/index";
export default {
  data() {
    return {
      timer: null,
      ctx:'',
      hLineNum:'',
      vLineNum:'',
      grid_width:'',
      x_start:'',
      width:'',
      height:'',
      ecglist:[],
      lineCtx:null,
      // list:[0.11451959609985352, 0.11793136596679688, 0.12108564376831055, 0.12398242950439453, 0.1266002655029297, 0.12894988059997559, 0.13099908828735352, 0.1327371597290039, 0.13416409492492676, 0.13525843620300293, 0.13602018356323242, 0.1364278793334961, 0.13648152351379395, 0.13618111610412598, 0.13551592826843262, 0.13448596000671387, 0.13309121131896973, 0.1313316822052002, 0.12920737266540527,0.1267075538635254, 0.12386441230773926, 0.1206672191619873, 0.1171267032623291, 0.11326432228088379, 0.1090693473815918, 0.10456323623657227, 0.09976744651794434, 0.09469270706176758, 0.08934974670410156, 0.083770751953125, 0.07796645164489746, 0.07195830345153809, 0.06576776504516602, 0.05941629409790039, 0.05292534828186035, 0.04632711410522461, 0.039621591567993164, 0.03286242485046387, 0.02606034278869629, 0.01923680305480957, 0.012423992156982422, 0.005643367767333984, -0.0010514259338378906, -0.007681846618652344, -0.014194250106811523, -0.02057790756225586, -0.02678990364074707, -0.032830238342285156, -0.03867745399475098, -0.04431009292602539, -0.0497281551361084, -0.05492091178894043, -0.059888362884521484, -0.06463050842285156, -0.06915807723999023, -0.0734710693359375, -0.07758021354675293, -0.0814962387084961, -0.08522987365722656, -0.08878111839294434, -0.09218215942382812, -0.09542226791381836, -0.09852290153503418, -0.10148406028747559, -0.10432720184326172, -0.10705232620239258, -0.10967016220092773, -0.11218070983886719, -0.11461615562438965, -0.11695504188537598, -0.11921882629394531, -0.12141823768615723, -0.12354254722595215, -0.12560248374938965, -0.12759804725646973, -0.12952923774719238, -0.13138532638549805, -0.13315558433532715, -0.13485074043273926, -0.13647079467773438, -0.1379835605621338, -0.13941049575805664, -0.14074087142944336, -0.14197468757629395, -0.1431119441986084, -0.14415264129638672, -0.14511823654174805, -0.1459980010986328, -0.14679193496704102, -0.1475214958190918, -0.14817595481872559, -0.14877676963806152, -0.14930248260498047, -0.149763822555542, -0.15017151832580566, -0.15050411224365234, -0.1507723331451416, -0.15097618103027344, -0.15110492706298828, -0.15118002891540527, -0.15118002891540527, -0.15110492706298828, -0.15096545219421387, -0.15076160430908203, -0.15050411224365234, -0.15017151832580566, -0.14977455139160156, -0.14931321144104004, -0.14879822731018066, -0.14821887016296387, -0.14757513999938965].map(item => (item * 200 * 0.3 + 80).toFixed(6))
    };
  },
  components: {

  },
  props: [
    "dataContent"
  ],
  watch: {
    // dataContent: function (newVal, oldVal) {
    //   console.log(newVal,28)
    // },
  },
  computed: {},
  mounted() {
    
    this.ecglist = this.dataContent.split(",").map(item => (item * 200 * 0.3 + 80).toFixed(6))
    console.log(this.ecglist,'444444444444444444444444444')
    // console.log(this.list,'444444444444444444444444444')
    // this.timer = setInterval(() => {
    //   const randomNumbers = this.getRandomNumbers(this.list, 19);
    //   this.ecglist = [...this.ecglist, ...randomNumbers];
    //   console.log(this.ecglist,'ecglistecglist')
    // }, 3000);
 
    

    var canvas = document.getElementById("background");
    this.width = canvas.width;
    this.height = canvas.height;
    this.ctx = canvas.getContext("2d");
    this.grid_width = 3; // 每一个小网格的宽高
    this.hLineNum = parseInt(this.height / this.grid_width); // 横线个数
    this.vLineNum = parseInt(this.width / this.grid_width); // 竖线个数
    this.x_start = this.grid_width * 3; // X起点，从第二个大格子开始画
    var lineCanvas = document.getElementById("line");
    this.lineCtx = lineCanvas.getContext("2d");
    this.lineCtx.lineWidth = 1.5;
    this.lineCtx.strokeStyle = "#0f0";
    // console.log(this.lineCtx)
    class WaveView {
      currentX = 0;
      currentY = 0;
      lastX = 0;
      lastY = 0;
      width=0;
      // 每次画几个点
      step = 50;
      // Y值最大值
      yMax = 300;
      // 每个波形的高度
      itemHeight = 100;
      // 橡皮檫宽度
      clearGap = 2;
      y_offset = 0;
      lineCtx='';
      grid_width='';
      // 队列
      queue = [];
      strokeStyle = "#0f0";
      timer= null
      /**
       * @param frameSize 1秒多少个点
       * @param yMax
       * @param y_offset y偏移
       * @param step 每次画几个点
       * @param speedRatio 扫纸速度，默认 25mm/s (1秒25个小格子 每个小格子0.04s)。 0.5表示扫纸速度为 12.5mm/s。2表示扫纸速度为 50mm/s。
       * @param strokeStyle 线的样式
       */
      constructor(frameSize, yMax, y_offset, step, speedRatio, strokeStyle,lineCtx,x_start,grid_width,width) {
        this.frameSize = frameSize;
        this.yMax = yMax;
        this.lastY = this.itemHeight / 2;
        this.y_offset = y_offset;
        this.step = step;
        this.lastX = 0
        this.width = width
        this.x_start = x_start
        this.speedRatio = speedRatio;
        this.strokeStyle = strokeStyle;
        this.lineCtx = lineCtx;
        this.grid_width = grid_width
        this.drawInterval = Math.floor((1 / this.frameSize) * 1000 * this.step); // 绘制时间间隔
        
      }

      draw = () => {
        // console.log(this.currentX,'99999999')
        this.lineCtx.beginPath();
        this.lineCtx.strokeStyle = this.strokeStyle;
        if (this.lastX === 0) {
          this.lineCtx.clearRect(this.x_start - 2, this.y_offset - 100,this.clearGap, this.itemHeight + 20000);
        } else {
          this.lineCtx.clearRect(this.x_start + this.lastX + 3, this.y_offset - 100,this.clearGap, this.itemHeight + 20000);
        }

        for (let i = 0; i < this.step; i++) {
          if (this.queue.length === 0) {
            this.currentY = this.itemHeight / 2;
          } else {
            this.currentY = (-1.0 * this.queue.shift()) / this.yMax * this.itemHeight + this.itemHeight;
          }

          if (this.currentY > this.itemHeight) {
            this.currentY = this.itemHeight;
          }

          this.lineCtx.moveTo(this.x_start + this.lastX, this.y_offset + this.lastY);
          this.lineCtx.lineTo(this.x_start + this.currentX, this.y_offset + this.currentY);
     
          this.lastX = this.currentX;
          this.lastY = this.currentY;
        
          this.currentX += (this.grid_width * 25 * this.speedRatio) / this.frameSize;
          if (this.x_start + this.currentX >= this.width - 25) {
            this.currentX = 0;
            this.lastX = 0;
          }
        }

        this.lineCtx.stroke();
      }

      loop = () => {
        this.draw();
        // setTimeout(this.loop, this.drawInterval);
       this.timer = setTimeout(this.loop, this.drawInterval);
       const url = new URL(window.location.href);
       if (url.hash.slice(0, -23) != '#/theHeart?ecg=1') {
        clearInterval(this.timer);
         this.timer = null;
       }
      }

      addData = (arr) => {
        this.queue=arr
      }
    }
    // console.log(this.$route.path)
    let ecgWave = new WaveView(512, 120, 80, 10, 1, '#00ff00',this.lineCtx,this.x_start,this.grid_width,this.width);
     console.log(this.ecglist,'00000000000')
    this.drawGrid();
    this.addfilltext();
    ecgWave.addData(this.ecglist)
    ecgWave.loop();
  },
  beforeCreate() {

  },
  unmounted() {
    this.lineCtx = []
  },
  methods: {
    getRandomNumbers(arr, count) {
  const result = new Array(count);
  let index = arr.length;
  let randomIndex;
 
  while (count--) {
    randomIndex = Math.floor(Math.random() * index);
    result[count] = arr[randomIndex];
    arr[randomIndex] = arr[index - 1];
    index--;
  }
 
  return result;
},
    drawGrid() {
      this.ctx.beginPath();
      this.ctx.lineWidth = 1;
      this.ctx.strokeStyle = "#ffbebe";
      for (let i = 0; i < this.hLineNum; i++) {
        if (i == 0 || i % 5 != 0) {
          this.ctx.moveTo(0, i * this.grid_width);
          this.ctx.lineTo(this.width, i * this.grid_width);
          this.ctx.stroke();
        }
      }

      this.ctx.beginPath();
      this.ctx.lineWidth = 1;
      this.ctx.strokeStyle = "#ffbebe";
      for (let i = 0; i < this.vLineNum; i++) {
        if (i == 0 || i % 5 != 0) {
          this.ctx.moveTo(i * this.grid_width, 0);
          this.ctx.lineTo(i * this.grid_width, this.height);
          this.ctx.stroke();
        }
      }
      this.ctx.beginPath();
      this.ctx.lineWidth = 1;
      this.ctx.strokeStyle = "#FF7F50";
      for (let i = 5; i <= this.vLineNum; i += 5) {
        this.ctx.moveTo(i * this.grid_width, 0);
        this.ctx.lineTo(i * this.grid_width, this.height);
        this.ctx.stroke();
      }

      this.ctx.beginPath();
      this.ctx.lineWidth = 1;
      this.ctx.strokeStyle = "#FF7F50";
      for (let i = 5; i <= this.hLineNum; i += 5) {
        this.ctx.moveTo(0, i * this.grid_width);
        this.ctx.lineTo(this.width, i * this.grid_width);
        this.ctx.stroke();
      }
    },
    addfilltext() {
      var waves = ["", "", ""];
      this.ctx.font = "bold 14px";
      this.ctx.fillText("" + waves[0] + "", 5, 50)
      this.ctx.fillText("" + waves[1] + "", 5, 150)
      this.ctx.fillText("" + waves[2] + "", 5, 250)
    },
  
  },
};
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
.boack {
      position: absolute;
      left: 0px;
      top: 10px;
      width: 100%;
  height: 160px;
    }
    #background {
      height: 3.7rem;
      width:90%;
      margin-left: 20px;
    }
    #line {
      height: 3.5rem;
      width:90%;
      margin-left: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/views/theHeart/ecg.vue